<div *ngIf="routerAccess">
   <button (click)="back()" kendoButton><i class="k-icon k-i-arrow-chevron-left"></i> Back</button>
</div>
<div class="k-overlay" *ngIf="opened"></div>
<kendo-window [title]="ModalTitle" *ngIf="opened" (close)="close(false)" [@fadeInOnEnter]>
   <div class="row">
      <div *ngIf="isNewMode" class="col-md-12">
         <app-information-box [infoLines]="['Search and select an asset. Then complete the upgrade information']"></app-information-box>
      </div>
      <div *ngIf="isNewMode" class="col-md-6">
         <app-asset-selection [method]="'ALL'" (assetSelected)="assetSelected($event)"></app-asset-selection>
      </div>
      <div [ngClass]="{ 'col-md-6': isNewMode, 'col-md-12': !isNewMode }">
         <mdb-card cascade="true" narrower="true">
            <div class="special-color text-white d-flex justify-content-center p-3">
               <h5><i class="fa fa-redo mr-1"></i>Upgrade Info</h5>
            </div>
            <div class="red-text error-text" *ngIf="isOriginateFromWip">
               This transaction originated from WIP. Changing values will also have an impact on WIP
            </div>
            <form class="k-form p-3" [formGroup]="upgradeForm" (ngSubmit)="save()" [appHasRoleDisable]="['SYSTEM-ADMIN', 'UPG-CR', 'UPG-ED']">
               <div class="row">
                  <div class="col-md-12">
                     <div>
                        <kendo-floatinglabel text="Barcode *" class="w-100">
                           <input kendoTextBox id="barcodeEdit" name="barcode" formControlName="barcode" class="w-100" />
                        </kendo-floatinglabel>
                        <div
                           class="red-text error-text"
                           *ngIf="upgradeForm.controls['barcode'].hasError('required') && (upgradeForm.controls['barcode'].dirty || upgradeForm.controls['barcode'].touched)"
                        >
                           Barcode required
                        </div>
                        <div class="red-text error-text" *ngIf="upgradeForm.controls['barcode'].hasError('maxlength')">Max Length of 50 allowed</div>
                     </div>
                     <div>
                        <kendo-floatinglabel text="Upgrade Date *" class="w-100">
                           <kendo-datepicker [format]="'dd-MMM-yyyy'" formControlName="upgradeDate"></kendo-datepicker>
                        </kendo-floatinglabel>
                        <div
                           class="red-text error-text"
                           *ngIf="
                              upgradeForm.controls['upgradeDate'].hasError('required') && (upgradeForm.controls['upgradeDate'].dirty || upgradeForm.controls['upgradeDate'].touched)
                           "
                        >
                           Upgrade Date Required
                        </div>
                     </div>
                     <div>
                        <kendo-floatinglabel text="Upgrade Amount *" class="w-100">
                           <kendo-numerictextbox [format]="'c'" formControlName="upgradeAmount" class="w-100"></kendo-numerictextbox>
                        </kendo-floatinglabel>
                        <div
                           class="red-text error-text"
                           *ngIf="
                              upgradeForm.controls['upgradeAmount'].hasError('required') &&
                              (upgradeForm.controls['upgradeAmount'].dirty || upgradeForm.controls['upgradeAmount'].touched)
                           "
                        >
                           Upgrade Amount Required
                        </div>
                     </div>
                     <div>
                        <kendo-floatinglabel text="Supplier" class="w-100">
                           <kendo-dropdownlist
                              formControlName="supplierId"
                              class="w-100"
                              [data]="dataSuppliers"
                              [filterable]="true"
                              [textField]="'name'"
                              [valueField]="'id'"
                              [valuePrimitive]="true"
                              (filterChange)="handleFilterSupplier($event)"
                           >
                              <ng-template kendoDropDownListItemTemplate let-dataItem> {{ dataItem.name }} - {{ dataItem.id }} </ng-template>
                           </kendo-dropdownlist>
                        </kendo-floatinglabel>
                     </div>

                     <div>
                        <kendo-floatinglabel text="Invoice Number" class="w-100">
                           <input kendoTextBox id="invoiceNumberEdit" name="invoiceNumber" formControlName="invoiceNumber" class="w-100" />
                        </kendo-floatinglabel>
                        <div class="red-text error-text" *ngIf="upgradeForm.controls['invoiceNumber'].hasError('maxlength')">Max Length of 50 allowed</div>
                     </div>
                     <div>
                        <kendo-floatinglabel text="Tender Number" class="w-100">
                           <input kendoTextBox id="tenderNumberEdit" name="tenderNumber" formControlName="tenderNumber" class="w-100" />
                        </kendo-floatinglabel>
                        <div class="red-text error-text" *ngIf="upgradeForm.controls['tenderNumber'].hasError('maxlength')">Max Length of 50 allowed</div>
                     </div>
                     <div>
                        <kendo-floatinglabel text="Vote Number" class="w-100">
                           <input kendoTextBox id="voteNumberEdit" name="voteNumber" formControlName="voteNumber" class="w-100" />
                        </kendo-floatinglabel>
                        <div class="red-text error-text" *ngIf="upgradeForm.controls['voteNumber'].hasError('maxlength')">Max Length of 50 allowed</div>
                     </div>
                     <div>
                        <kendo-floatinglabel text="Reference Number" class="w-100">
                           <input kendoTextBox id="referenceNumberEdit" name="referenceNumber" formControlName="referenceNumber" class="w-100" />
                        </kendo-floatinglabel>
                        <div class="red-text error-text" *ngIf="upgradeForm.controls['referenceNumber'].hasError('maxlength')">Max Length of 100 allowed</div>
                     </div>
                     <kendo-floatinglabel text="Description *" class="w-100">
                        <textarea kendoTextArea id="descriptionEdit" name="description" formControlName="description" class="w-100"></textarea>
                     </kendo-floatinglabel>
                     <div class="red-text error-text" *ngIf="upgradeForm.controls['description'].hasError('maxlength')">Max Length of 200 allowed</div>
                     <div
                        class="red-text error-text"
                        *ngIf="
                           upgradeForm.controls['description'].hasError('required') && (upgradeForm.controls['description'].dirty || upgradeForm.controls['description'].touched)
                        "
                     >
                        Description required
                     </div>
                  </div>
               </div>

               <div class="modal-footer d-flex justify-content-center">
                  <div *appHasRole="['SYSTEM-ADMIN', 'UPG-CR', 'UPG-ED']">
                     <button *ngIf="!loading" [disabled]="upgradeForm.invalid" look="flat" kendoButton type="submit" icon="save" [primary]="true">Save</button>
                  </div>
                  <div class="red-text" *appHasNotRole="['SYSTEM-ADMIN', 'UPG-CR', 'UPG-ED']">You do not have permission to edit.</div>
                  <mdb-spinner *ngIf="loading" spinnerType="small"></mdb-spinner>
               </div>
            </form>
         </mdb-card>
      </div>
   </div>
</kendo-window>
